import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import React, { useEffect, useState } from "react"
import { Flex, Box } from "theme-ui"
import { 
  faPlus, 
  faEllipsisH 
} from '@fortawesome/free-solid-svg-icons'
import Select from "react-select"

import NewBoxButton from "../Radiate/NewBoxButton/NewBoxButton"

import * as Styles from "./LocalisedSelectionListStyles"

const LocalisedSelectionList = ({
  info,
  selectedLg,
  selectedType,
  onChangeSelectedLg,
  onChangeSelectedType,
  onAddLocalised,
  onRemoveLocalised,
}) => {
  // console.log("LocalisedSelectionList info", info)
  // console.log("selectedLg", selectedLg)
  // console.log("selectedType", selectedType)
  const localised = info?.chatConfiguration?.localised || []
  const [open, setOpen] = useState(selectedLg)
  const [showDropDown, setShowDropDown] = useState(false)
  const [selectedLocaleGroup, setSelectedLocaleGroup] = useState(null)

  useEffect(() => {
    setOpen(selectedLg)
  }, [selectedLg])
  const localeGroupOptions = (info?.localeGroups || []).map((lg) => {
    return ({
      label: lg.name,
      value: lg.id,
      isDisabled: localised.find(o => o.localeId === lg.id)
    })
  })
  return (
    <Box mr={3} p={2}
      sx={{
        width: "240px",
        height: "100%",
        overflowY: "scroll",
        border: "1px solid #e8e7e8",
        borderRadius: "6px",
        position: "relative",
      }}>
      {localised.map((lg, i) => {
        const localeGroup = (info?.localeGroups || []).find(o => o.id === lg.localeId)
        // console.log("lg", lg)
        // console.log("open", open)
        return (
          <Styles.LocalisedButton
            selected={selectedLg === lg.localeId}
            open={open === lg.localeId}
          >
            <Styles.LocaleGroupButton
              className="locale-group-button"
              onClick={() => {
                if (selectedLg === lg.localeId) {
                  setOpen(null)
                  onChangeSelectedLg(null)
                } else {
                  onChangeSelectedType("iceBreakers")
                  onChangeSelectedLg(lg.localeId)
                  setOpen(lg.localeId)
                }
              }}
            >
              <Flex>
                <div className="locale-group-name">{localeGroup?.name || lg?.name || ""}</div>
                {localeGroup?.default &&
                  <Styles.Tag>
                    Default
                  </Styles.Tag>
                }
              </Flex>
              {!localeGroup?.default &&
                <Box>
                  <Styles.SDropdownMenu
                    className="delete-button"
                    key="delete-button"
                    icon={faEllipsisH}
                    borderless
                    placement="bottom-end"
                    buttons={[
                      {
                        label: "Remove",
                        danger: true,
                        onClick: () => {
                          onRemoveLocalised(localeGroup.id)
                        }
                      }
                    ]}
                  />
                </Box>
              }
            </Styles.LocaleGroupButton>
            <Styles.TypeButtonWrapper
              open={open === lg.localeId}
            >
              <Styles.TypeButton
                selected={selectedType === "iceBreakers" && open === lg.localeId}
                onClick={() => {
                  onChangeSelectedType("iceBreakers")
                }}
              >
                Ice Breakers
              </Styles.TypeButton>
              <Styles.TypeButton
                selected={selectedType === "persistentMenu" && open === lg.localeId}
                onClick={() => {
                  onChangeSelectedType("persistentMenu")
                }}
              >
                Persistent Menu
              </Styles.TypeButton>
            </Styles.TypeButtonWrapper>
          </Styles.LocalisedButton>
        )
      })}

      <Styles.StyledPopperContainer
        show={showDropDown}
        display={(
          <Styles.AddLocalisedButton
            onClick={() => {
              setShowDropDown(true)
            }}
          >
            <FontAwesomeIcon
              icon={faPlus}
              className="icon"
            />
            Add Locale
          </Styles.AddLocalisedButton>
        )}
        placement="bottom-start"
        displayDisplay="block"
        onClickOutside={() => {
          setShowDropDown(false)
        }}
      >
        <Styles.AddLocaleGroupContainer>
          <Select
            options={localeGroupOptions}
            value={selectedLocaleGroup}
            onChange={(value) => {
              setSelectedLocaleGroup(value)
            }}
          />
          <NewBoxButton
            className="confirm-button"
            primary
            disabled={!selectedLocaleGroup}
            text="Confirm"
            onClick={() => {
              onAddLocalised(selectedLocaleGroup)
              setShowDropDown(false)
              setSelectedLocaleGroup(null)
            }}
          />
        </Styles.AddLocaleGroupContainer>
      </Styles.StyledPopperContainer>
      
    </Box>
  )
}

export default LocalisedSelectionList